/*
 * @Author: yaoyuting
 * @Date: 2019-08-28 21:56:10
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-05-10 15:43:34
 * @Descripttion:
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/reset.css";
// import '@/assets/common.css';
// import '@/views/pc/common.less'
// import '@/canvas.js'
import i18n from "@/i18n/i18n.js";

import ElementUI from "element-ui";
import { goPAGE } from "./utils/utils";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/font/iconfont.css";
//import "@/assets/font/font.css";
import "@/assets/font/iconfont.js";
import animate from 'animate.css';

import plugin from "./utils/Bus";
import axios from "axios";
import "wowjs/css/libs/animate.css";
import VueScrollReveal from "vue-scroll-reveal";
import { Notify, Icon, Popup } from "vant";
// import echarts from "echarts";
//图片插件
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer';
import 'vue-directive-image-previewer/dist/assets/style.css';
Vue.use(VueDirectiveImagePreviewer, {
  zIndex: 9999999,  //层级显示
  previewSize: 3, //三倍图
  cursor: 'pointer',
})
Vue.prototype.$axios = axios;
// Vue.prototype.$echarts = echarts;
// import VueQuillEditor from 'vue-quill-editor';//编辑器
// import 'quill/dist/quill.core.css';
// import 'quill/dist/quill.snow.css';
// import 'quill/dist/quill.bubble.css';
// Vue.use(VueQuillEditor);
//编辑器

import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';
Vue.use(VueFileAgent);


// Vue.prototype.$echarts = echarts;

import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);

Vue.prototype.$http = axios;
Vue.use(plugin);

const classify = goPAGE();


Vue.use(ElementUI);



Vue.use(VueScrollReveal, {
  duration: 2000,
  scale: 1,
  distance: "200px",
  reset: true,
  mobile: false,
  useDelay: "always",
  origin: "bottom",
  easing: "linear",
});

Vue.config.productionTip = false;
// import VueAnimateNumber from 'vue-animate-number'
// Vue.use(VueAnimateNumber)
// if (goPAGE() == "pc") {
//   router.push({ path: "/pc/Index" });
// } else {
//   router.push({ path: "/m/Index" });
// }
if (goPAGE() == 'm') {
  router.push({ path: '/' });
}
 else {
  router.push({ path: '/' });
}

Vue.use(Popup);
Vue.use(Icon);
// 全局注册
Vue.use(Notify);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

router.beforeEach((to, from, next) => {
  if (to.fullPath.indexOf(classify) == -1) {
    next(`/${classify}`);
  }
  // chrome
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  // safari
  window.pageYOffset = 0;
  next();
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
